import { PapiDeviationBackground } from '@wix/da-papi-types';

const backgrounds: PapiDeviationBackground[] = [
  {
    backgroundId: 1,
    position: 2,
    isPremium: false,
    darkThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/00-dark-thumb.png',
    darkBigUrl: 'https://st.deviantart.net/deviations/backgrounds/00-dark.jpg',
    darkSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/00-dark-small.jpg',
    lightThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/00-light-thumb.png',
    lightBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/00-light.jpg',
    lightSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/00-light-small.jpg',
    greenThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/00-green-thumb.jpg?1',
    greenBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/00-green.png',
    greenSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/00-green-small.png',
  },
  {
    backgroundId: 8,
    position: 3,
    isPremium: true,
    darkThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/07-dark-thumb.png',
    darkBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/07-dark.jpg?1',
    darkSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/07-dark-small.jpg?1',
    lightThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/07-light-thumb.png',
    lightBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/07-light.jpg?2',
    lightSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/07-light-small.jpg?2',
    greenThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/07-green-thumb.jpg?1',
    greenBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/07-green.jpg?1',
    greenSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/07-green-small.jpg?1',
  },
  {
    backgroundId: 4,
    position: 4,
    isPremium: true,
    darkThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/03-dark-thumb.png',
    darkBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/03-dark.jpg?1',
    darkSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/03-dark-small.jpg?1',
    lightThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/03-light-thumb.png',
    lightBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/03-light.jpg?1',
    lightSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/03-light-small.jpg?1',
    greenThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/03-green-thumb.jpg?1',
    greenBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/03-green.jpg?1',
    greenSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/03-green-small.jpg?1',
  },
  {
    backgroundId: 12,
    position: 5,
    isPremium: true,
    darkThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/11-dark-thumb.png',
    darkBigUrl: 'https://st.deviantart.net/deviations/backgrounds/11-dark.jpg',
    darkSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/11-dark-small.jpg',
    lightThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/11-light-thumb.png',
    lightBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/11-light.jpg',
    lightSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/11-light-small.jpg',
    greenThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/11-green-thumb.jpg',
    greenBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/11-green.jpg',
    greenSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/11-green-small.jpg',
  },
  {
    backgroundId: 13,
    position: 6,
    isPremium: true,
    darkThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/12-dark-thumb.png',
    darkBigUrl: 'https://st.deviantart.net/deviations/backgrounds/12-dark.jpg',
    darkSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/12-dark-small.jpg',
    lightThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/12-light-thumb.png',
    lightBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/12-light.jpg',
    lightSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/12-light-small.jpg',
    greenThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/12-green-thumb.jpg',
    greenBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/12-green.jpg',
    greenSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/12-green-small.jpg',
  },
  {
    backgroundId: 11,
    position: 7,
    isPremium: true,
    darkThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/10-dark-thumb.png',
    darkBigUrl: 'https://st.deviantart.net/deviations/backgrounds/10-dark.jpg',
    darkSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/10-dark-small.jpg',
    lightThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/10-light-thumb.png',
    lightBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/10-light.jpg',
    lightSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/10-light-small.jpg',
    greenThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/10-green-thumb.jpg',
    greenBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/10-green.jpg',
    greenSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/10-green-small.jpg',
  },
  {
    backgroundId: 6,
    position: 8,
    isPremium: true,
    darkThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/05-dark-thumb.png',
    darkBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/05-dark.jpg?1',
    darkSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/05-dark-small.jpg?1',
    lightThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/05-light-thumb.png',
    lightBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/05-light.jpg?2',
    lightSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/05-light-small.jpg?2',
    greenThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/05-green-thumb.jpg?1',
    greenBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/05-green.jpg',
    greenSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/05-green-small.jpg?1',
  },
  {
    backgroundId: 10,
    position: 9,
    isPremium: true,
    darkThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/09-dark-thumb.png',
    darkBigUrl: 'https://st.deviantart.net/deviations/backgrounds/09-dark.jpg',
    darkSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/09-dark-small.jpg',
    lightThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/09-light-thumb.png',
    lightBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/09-light.jpg',
    lightSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/09-light-small.jpg',
    greenThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/09-green-thumb.jpg',
    greenBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/09-green.jpg',
    greenSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/09-green-small.jpg',
  },
  {
    backgroundId: 7,
    position: 10,
    isPremium: true,
    darkThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/06-dark-thumb.png',
    darkBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/06-dark.jpg?1',
    darkSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/06-dark-small.jpg?1',
    lightThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/06-light-thumb.png',
    lightBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/06-light.jpg?1',
    lightSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/06-light-small.jpg?1',
    greenThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/06-green-thumb.jpg?1',
    greenBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/06-green.jpg?1',
    greenSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/06-green-small.jpg?1',
  },
  {
    backgroundId: 3,
    position: 11,
    isPremium: true,
    darkThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/02-dark-thumb.png',
    darkBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/02-dark.jpg?1',
    darkSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/02-dark-small.jpg?1',
    lightThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/02-light-thumb.png',
    lightBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/02-light.jpg?1',
    lightSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/02-light-small.jpg?1',
    greenThumbUrl:
      'https://st.deviantart.net/deviations/backgrounds/02-green-thumb.jpg?1',
    greenBigUrl:
      'https://st.deviantart.net/deviations/backgrounds/02-green.jpg?1',
    greenSmallUrl:
      'https://st.deviantart.net/deviations/backgrounds/02-green-small.jpg?1',
  },
];

export function getBackgrounds(offset = 0, limit = 10) {
  return backgrounds.slice(offset, Number(offset) + Number(limit));
}

export function randomBackground() {
  const offset = Math.round(Math.random() * backgrounds.length);
  return backgrounds[offset];
}

export function getNonPremiumBackground() {
  return backgrounds.find(b => !b.isPremium);
}

export function getCoreOnlyBackground() {
  return backgrounds.find(b => b.isPremium);
}
